import type { FaireProductEntity } from "../../entity_types/product";

export const p_1tyhbogr: FaireProductEntity = {
  token: "p_1tyhbogr",
  type: "product",
  name: "French Lavender Bath Bomb",
  brandToken: "b_cb27ceb3",
  brandName: "Old Whaling Company",
  imageUrl:
    "https://cdn.faire.com/fastly/ad1d8a8cb872db97abd6483d51b0083133b8113b491b9f9259303dbad9cb0242.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/4c7b0ae32158c77e843449efe477ba9186bcc3e546c9de48407a841be33700b7/1530915973.jpg",
    "https://cdn.faire.com/fastly/78519152920a291756e1de1d09a4ae6d98527eaeda683de421d5c24735b3716a.jpeg",
    "https://cdn.faire.com/fastly/bcb394fd9f4f5baaa1233ca8efcc614de3fec7ea3d5a83d6b457ada4611a7bad.jpeg",
    "https://cdn.faire.com/fastly/c9b82b5bab6fcfcabf22f5c6e9f67a937fe2b58dfa558543f16a4cda676cf1a7.jpeg",
    "https://cdn.faire.com/fastly/fc06cdd97669d593aa810716dd0f8026a5ad91813086e2404973ba8e1c39c989.jpeg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/e5e00c095e0609c07c65c8b996bd8bd25c0308757545100fe59900633c3fc940/1536338083.jpg",
    "https://cdn.faire.com/fastly/8ea2efdd12586cc982bccaa0aa47f07d258518ffc1b3a4b31f92c6e482805e69.jpeg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/09ebc09a07775d370edb777759ba06d9e67e370bc76dd2910f4228dc1ad00cfa/1534447543.jpg",
    "https://cdn.faire.com/fastly/58cfe95c6fdcbca718f484c08c705925c3988b35428c9091b19e34de11c84b4f.jpeg",
    "https://cdn.faire.com/fastly/c87f359a9b20a4a89490e2729a214915c4e6f39a5c3d0442a489542f0a5259dd.jpeg",
  ],
  priceDollars: 4,
  description:
    "A tranquil, floral blend with notes of mountain heather & wild rose. A favorite fragrance for inspiring sleep and serenity, this soothing scent is reminiscent of a gentle breeze rolling through a peaceful meadow of wild lavender. \n\nTop: Lavender, Mountain Heather, Rose\nBase: Lilac, Tonka, Orange Flower\n\nHandmade in historic Charleston, SC, with baking soda, citric acid, epsom salts, olive, and soybean oil, each 8oz bath bomb will leave your skin feeling moisturized and lightly scented. Our handcrafted bath bomb's soothing fizz and sea-inspired fragrance are perfect for a relaxing soak, rejuvenating the senses and cleansing the skin.\n\nOur bath bombs come individually boxed, and are wrapped in cellophane bags inside the box to prevent oil from seeping into the packaging. \n\nOur bath bombs always make for great gifts! \n",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:10.340Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
